<div class="ftp-users">
  @if (filteredUsers$ | async; as records) {
    <app-search-field
      placeholder="Search"
      id="record-search"
      (searchText)="onSearch($event)"
    ></app-search-field>

    <div class="table-container">
      <div class="header row">
        <h2>FTP Users</h2>
        <div class="buttons row">
          <button matButton="filled" (click)="addFTPUser()">
            <fa-icon [icon]="['fas', 'user-plus']" size="lg"></fa-icon>
            Add FTP User
          </button>
          <button matButton="outlined">
            <fa-icon [icon]="['fas', 'arrow-up-right-from-square']" size="lg"></fa-icon>
            File manager
          </button>
        </div>
      </div>

      <mat-card appearance="outlined" class="users">
        <app-table
          #table
          [columns]="usersColumns"
          [dataSource]="records"
          [totalCount]="allUsersCount()"
          (pageChange)="handlePageEvent($event)"
        >
          <ng-container matColumnDef="user">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>FTP User</th>
            <td mat-cell *matCellDef="let element">
              <mat-slide-toggle
                [checked]="element.status !== 6"
                (change)="toggleUser($event, element)"
              ></mat-slide-toggle>
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let element">
              <app-status-label [status]="toStatus(element.status)"></app-status-label>
            </td>
          </ng-container>

          <ng-container matColumnDef="buttons">
            <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
            <td mat-cell *matCellDef="let element">
              <div class="buttons">
                <button
                  matRipple
                  class="button"
                  matTooltip="Open File Manager"
                  [matTooltipShowDelay]="500"
                  matTooltipPosition="above"
                >
                  <fa-icon [icon]="['fas', 'arrow-right-to-bracket']" size="lg"></fa-icon>
                </button>

                <button
                  matRipple
                  class="button"
                  matTooltip="FTP User Settings"
                  [matTooltipShowDelay]="500"
                  matTooltipPosition="above"
                  (click)="openUserSettings(element)"
                >
                  <fa-icon [icon]="['fas', 'gear']" size="lg"></fa-icon>
                </button>
                <button
                  matRipple
                  class="button"
                  matTooltip="Delete FTP User"
                  [matTooltipShowDelay]="500"
                  matTooltipPosition="above"
                  (click)="deleteUser(element)"
                >
                  <fa-icon [icon]="['fas', 'trash']" size="lg"></fa-icon>
                </button>
              </div>
            </td>
          </ng-container>
        </app-table>
      </mat-card>
    </div>
  }
</div>
